import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/Wishlist/Wishlist.js
const Wishlist = createSectionForm({
  icon: "heart-line",
  title: "Wishlist",
  fields: [{ name: "title", label: "Title", placeholder: "Wishlist" }],
});

export default Wishlist;
